// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ExploreTrips_entry-div__XAiDO{
    width: 100vw;
    height: 20vw;
    margin-top: -5vw;
 }
 .ExploreTrips_entry-img__7TqFQ{
    position: absolute;
    width: 100vw;
    height: 40vw;
    object-fit: cover;
    margin-top: -10vw;
    z-index: -1;
 }
 .ExploreTrips_entry-things__Lzd3o{
    position: absolute;
    width: 100vw;
    height: auto;
    margin-top: 9vw;
 }
 
 
 .ExploreTrips_entry-heading__Qsu4B{
    text-align: center;
    font-size: 5.3vw;
    margin-top: 0;
    margin-bottom: 0;
    font-weight: 500;
    font-family: dm-sans-medium;
    letter-spacing: -2.5px;
 }
 
 
 .ExploreTrips_month-container__hOLBn{
    margin-top: 4vw;
 }
 
 
 .ExploreTrips_month-name__BCO-e{
    font-size: 4vw;
    text-align: center;
    font-weight: 500;
    margin-bottom: 0;
    margin-top: 0;
 }
 
 
 .ExploreTrips_underline__6E7ka{
    color: rgb(230, 84, 57);
    font-size: 3vw;
    text-align: center;
    margin-top: -2.5vw;
    margin-bottom: 0px;
    font-family: sans-serif;
 }
 
 
 .ExploreTrips_month-dropdown__2Skn4{
    position: absolute;
    width: 20vw;
    height: 3.5vw;
    border: 1px solid rgba(119, 106, 106, 0.301);
    margin-left: 70vw;
    margin-top: -5vw;
    border-radius: 100vw;
 }
 
 
 .ExploreTrips_month-dropdown-adjust__6K9jE{
    position: absolute;
    margin-top: -4.5vw;
    margin-left: 70vw;
    margin-right: 5vw;
    /* width: 50vw;
    height: 5vw;
    background-color: black; */
 }
 
 
 .ExploreTrips_mobile-filter-container__QWcn2{
    display: none;
 }
 
 
 @media(max-width:768px){
    .ExploreTrips_entry-div__XAiDO{
        width: 100vw;
        height: 70vw;
        margin-top: -13vw;
    }
    .ExploreTrips_entry-img__7TqFQ{
        position: absolute;
        width: 100vw;
        height: 70vw;
        object-fit: cover;
        margin-top: -25vw;
        z-index: -1;
    }
 
 
    .ExploreTrips_entry-things__Lzd3o{
        position: absolute;
        width: 100vw;
        height: auto;
        margin-top: 9vw;
    }
   
    .ExploreTrips_entry-heading__Qsu4B{
        text-align: center;
        font-size: 8.5vw;
        margin-top: 13vw;
        margin-bottom: 0;
        font-weight: 500;
    }
 
 
    .ExploreTrips_desktop-filter-container__Q7fZA{
        display: none;
    }
 
 
    .ExploreTrips_month-container__hOLBn{
        margin-bottom: 7vw;
    }
   
    .ExploreTrips_month-name__BCO-e{
        font-size: 10vw;
        text-align: center;
        font-weight: 500;
        margin-bottom: 0;
        margin-top: 0;
    }
   
    .ExploreTrips_underline__6E7ka{
        color: rgb(230, 84, 57);
        font-size: 10vw;
        text-align: center;
        margin-top: -9vw;
        margin-bottom: 0px;
        font-family: serif;
    }
   
    .ExploreTrips_month-dropdown__2Skn4{
        display: none;
        position: absolute;
        width: 20vw;
        height: 3.5vw;
        border: 1px solid rgba(119, 106, 106, 0.301);
        margin-left: 70vw;
        margin-top: -5vw;
        border-radius: 100vw;
    }
 
 
    .ExploreTrips_mobile-filter-container__QWcn2{
        display: flex;
        position: absolute;
        margin-top: -25vw;
    }
 
 
    .ExploreTrips_mobile-filter-month__Q39hq{
        display: flex;
        position: relative;
        height: 20vw;
        margin-top: 5vw;
        z-index: 1;
        /* margin-bottom: 10vw; */
    }
 }
 `, "",{"version":3,"sources":["webpack://./src/Pages/ExploreTrips/ExploreTrips.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,YAAY;IACZ,gBAAgB;CACnB;CACA;IACG,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;CACd;CACA;IACG,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,eAAe;CAClB;;;CAGA;IACG,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,2BAA2B;IAC3B,sBAAsB;CACzB;;;CAGA;IACG,eAAe;CAClB;;;CAGA;IACG,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;CAChB;;;CAGA;IACG,uBAAuB;IACvB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;CAC1B;;;CAGA;IACG,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,4CAA4C;IAC5C,iBAAiB;IACjB,gBAAgB;IAChB,oBAAoB;CACvB;;;CAGA;IACG,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB;;8BAE0B;CAC7B;;;CAGA;IACG,aAAa;CAChB;;;CAGA;IACG;QACI,YAAY;QACZ,YAAY;QACZ,iBAAiB;IACrB;IACA;QACI,kBAAkB;QAClB,YAAY;QACZ,YAAY;QACZ,iBAAiB;QACjB,iBAAiB;QACjB,WAAW;IACf;;;IAGA;QACI,kBAAkB;QAClB,YAAY;QACZ,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,gBAAgB;QAChB,gBAAgB;QAChB,gBAAgB;IACpB;;;IAGA;QACI,aAAa;IACjB;;;IAGA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,gBAAgB;QAChB,aAAa;IACjB;;IAEA;QACI,uBAAuB;QACvB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,kBAAkB;QAClB,WAAW;QACX,aAAa;QACb,4CAA4C;QAC5C,iBAAiB;QACjB,gBAAgB;QAChB,oBAAoB;IACxB;;;IAGA;QACI,aAAa;QACb,kBAAkB;QAClB,iBAAiB;IACrB;;;IAGA;QACI,aAAa;QACb,kBAAkB;QAClB,YAAY;QACZ,eAAe;QACf,UAAU;QACV,yBAAyB;IAC7B;CACH","sourcesContent":[".entry-div{\n    width: 100vw;\n    height: 20vw;\n    margin-top: -5vw;\n }\n .entry-img{\n    position: absolute;\n    width: 100vw;\n    height: 40vw;\n    object-fit: cover;\n    margin-top: -10vw;\n    z-index: -1;\n }\n .entry-things{\n    position: absolute;\n    width: 100vw;\n    height: auto;\n    margin-top: 9vw;\n }\n \n \n .entry-heading{\n    text-align: center;\n    font-size: 5.3vw;\n    margin-top: 0;\n    margin-bottom: 0;\n    font-weight: 500;\n    font-family: dm-sans-medium;\n    letter-spacing: -2.5px;\n }\n \n \n .month-container{\n    margin-top: 4vw;\n }\n \n \n .month-name{\n    font-size: 4vw;\n    text-align: center;\n    font-weight: 500;\n    margin-bottom: 0;\n    margin-top: 0;\n }\n \n \n .underline{\n    color: rgb(230, 84, 57);\n    font-size: 3vw;\n    text-align: center;\n    margin-top: -2.5vw;\n    margin-bottom: 0px;\n    font-family: sans-serif;\n }\n \n \n .month-dropdown{\n    position: absolute;\n    width: 20vw;\n    height: 3.5vw;\n    border: 1px solid rgba(119, 106, 106, 0.301);\n    margin-left: 70vw;\n    margin-top: -5vw;\n    border-radius: 100vw;\n }\n \n \n .month-dropdown-adjust{\n    position: absolute;\n    margin-top: -4.5vw;\n    margin-left: 70vw;\n    margin-right: 5vw;\n    /* width: 50vw;\n    height: 5vw;\n    background-color: black; */\n }\n \n \n .mobile-filter-container{\n    display: none;\n }\n \n \n @media(max-width:768px){\n    .entry-div{\n        width: 100vw;\n        height: 70vw;\n        margin-top: -13vw;\n    }\n    .entry-img{\n        position: absolute;\n        width: 100vw;\n        height: 70vw;\n        object-fit: cover;\n        margin-top: -25vw;\n        z-index: -1;\n    }\n \n \n    .entry-things{\n        position: absolute;\n        width: 100vw;\n        height: auto;\n        margin-top: 9vw;\n    }\n   \n    .entry-heading{\n        text-align: center;\n        font-size: 8.5vw;\n        margin-top: 13vw;\n        margin-bottom: 0;\n        font-weight: 500;\n    }\n \n \n    .desktop-filter-container{\n        display: none;\n    }\n \n \n    .month-container{\n        margin-bottom: 7vw;\n    }\n   \n    .month-name{\n        font-size: 10vw;\n        text-align: center;\n        font-weight: 500;\n        margin-bottom: 0;\n        margin-top: 0;\n    }\n   \n    .underline{\n        color: rgb(230, 84, 57);\n        font-size: 10vw;\n        text-align: center;\n        margin-top: -9vw;\n        margin-bottom: 0px;\n        font-family: serif;\n    }\n   \n    .month-dropdown{\n        display: none;\n        position: absolute;\n        width: 20vw;\n        height: 3.5vw;\n        border: 1px solid rgba(119, 106, 106, 0.301);\n        margin-left: 70vw;\n        margin-top: -5vw;\n        border-radius: 100vw;\n    }\n \n \n    .mobile-filter-container{\n        display: flex;\n        position: absolute;\n        margin-top: -25vw;\n    }\n \n \n    .mobile-filter-month{\n        display: flex;\n        position: relative;\n        height: 20vw;\n        margin-top: 5vw;\n        z-index: 1;\n        /* margin-bottom: 10vw; */\n    }\n }\n "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"entry-div": `ExploreTrips_entry-div__XAiDO`,
	"entry-img": `ExploreTrips_entry-img__7TqFQ`,
	"entry-things": `ExploreTrips_entry-things__Lzd3o`,
	"entry-heading": `ExploreTrips_entry-heading__Qsu4B`,
	"month-container": `ExploreTrips_month-container__hOLBn`,
	"month-name": `ExploreTrips_month-name__BCO-e`,
	"underline": `ExploreTrips_underline__6E7ka`,
	"month-dropdown": `ExploreTrips_month-dropdown__2Skn4`,
	"month-dropdown-adjust": `ExploreTrips_month-dropdown-adjust__6K9jE`,
	"mobile-filter-container": `ExploreTrips_mobile-filter-container__QWcn2`,
	"desktop-filter-container": `ExploreTrips_desktop-filter-container__Q7fZA`,
	"mobile-filter-month": `ExploreTrips_mobile-filter-month__Q39hq`
};
export default ___CSS_LOADER_EXPORT___;
